import { useEffect } from 'react'
import { useCountryBlocking } from '@/contexts/CountryBlockingContext'
import { CountryBlockedModal } from './CountryBlockedModal'
import { setCountryBlockingCallback, clearCountryBlockingCallback } from '@/services/countryBlockingDetector'

export function CountryBlockingHandler() {
  const { countryBlocking, setCountryBlocking } = useCountryBlocking()

  useEffect(() => {
    // Set up the callback to receive country blocking notifications from the API interceptor
    setCountryBlockingCallback(setCountryBlocking)

    // Clean up the callback on unmount
    return () => {
      clearCountryBlockingCallback()
    }
  }, [setCountryBlocking])

  return (
    <CountryBlockedModal 
      isOpen={countryBlocking.isBlocked} 
      countryBlocking={countryBlocking}
    />
  )
}